import React, { useEffect, useMemo, useState } from "react";
import InnerHeader from "../etc/innerheader";
import { useLocation } from "react-router-dom";

import {
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    Sheet,
    Avatar,
    Typography,
    Button,
} from "@mui/joy";
import { CircularProgress } from "@mui/material";
import { postFetch } from "../../fetch/fetch";
import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";
import { useMediaQuery } from "react-responsive";

const MultipleUserLogin: React.FC<any> = (props) => {
    const headerRef = React.useRef<HTMLDivElement>(null);
    const location: any = useLocation();

    const [users, setUsers] = useState<any[]>([]);
    const [password, setPassword] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");

    const [bodyHeight, setBodyHeight] = useState(0);
    const [academyTotalSame, setAcademyTotalSame] = useState(false);

    const [selectedUserId, setSelectedUserId] = useState<string>("");

    const [loading, setLoading] = useState(false);
    const [isPc, setIsPc] = useState(false);

    const [currentScreen, setCurrentScreen] = useState("");
  const isMobile = useMediaQuery({
    query: `(max-width : 1024px)`
  })
  const isNotPc = useMediaQuery({
    query: `(max-width : 1025px)`
  })



  useEffect(() => {
    if (isMobile || Capacitor.isNativePlatform()) {
      setCurrentScreen("mobile");
    } else {
      setCurrentScreen("pc");
    }

  }, [isMobile, Capacitor.isNativePlatform()]);

    useEffect(() => {
        if (location.state && location.state.users) {
            const firstAcademy = location.state.users[0].academy;
            let allSame = true;
            for (let i = 1; i < location.state.users.length; i++) {
                if (location.state.users[i].academy !== firstAcademy) {
                    allSame = false;
                    break;
                }
            }
            setAcademyTotalSame(allSame);

            setUsers(location.state.users);
            setPassword(location.state.password);
            setPhoneNumber(location.state.phoneNumber);
            setIsPc(location.state.pc);

            setSelectedUserId("");
        } else {
            props.history.goBack();
        }
    }, [location.state]);

    useEffect(() => {
        if (!headerRef?.current) return;

        const calc = () => {
            if (!headerRef?.current) return;
            setBodyHeight(window.innerHeight - headerRef.current.offsetHeight);
        };

        const afterDelay = () => setTimeout(calc, 50);

        afterDelay();
        window.addEventListener("resize", afterDelay);
        return () => window.removeEventListener("resize", afterDelay);
    }, []);

    const userItems = useMemo(() => {
        return users.map((u: any) => ({
            ...u,
            _radioId: String(u.id),
        }));
    }, [users]);

    const roleLabel = (value: string) => {
        switch (value) {
            case "student":
                return "학생";
            case "parent":
                return "학부모";
            case "teacher":
                return "직원";
            default:
                return value ?? "";
        }
    };

    const displayName = (user: any) => {
        // 학부모면: 학생이름 + 학부모 (본인 이름)
        if (user.value === "parent") {
            const student = user.studentName ?? "";
            const me = user.name ?? "";
            // studentName이 없을 수도 있으니 방어
            if (student && me) return `${student}`;
            if (student) return `${student}`;
            return `${me} 학부모`;
        }
        return user.name ?? "";
    };

    const handleStart = () => {
        if (!selectedUserId) return;
        const selectedUser = userItems.find((u) => u._radioId === selectedUserId);
        console.log("선택된 유저:", selectedUser, { password, phoneNumber });
        // TODO: 로그인 처리
    };

    const submit = async () => {

        try {

            if (!selectedUserId) {
                alert("계정을 선택해주세요.");
                return;
            }

            setLoading(true);

            const result: any = await postFetch("/login/loginbymultiple", {
                phoneNumber,
                password,
                userId: selectedUserId
            });

            setLoading(false);

            console.log(result);

            if (result.message === "success") {

                if (window.electron) {
                    const returnValue = window.electron.sendMessageApi.setToken(result.token);
                }

                if (Capacitor.isNativePlatform()) {

                    const token = result.token;

                    await Preferences.set({
                        key: "token",
                        value: token
                    })
                }

                var location = currentScreen === "pc" ? "/dashboard" : "/mobiledashboard";

                props.history.push(location);

            } else {
                alert("자동 로그인에 실패했습니다. 다시 시도해주세요.");
            }

        } catch (e) {
            console.log(e);
        }

    }

    return (
        <div style={{
            maxWidth: isPc ? "500px" : "none",
            margin: isPc ? "0 auto" : "none",
        }} 
        onKeyDown={(e) => {
        if (e.key === "Enter" && (selectedUserId) && !loading) {
            submit();
        }
    }}
        >
            <InnerHeader headerRef={headerRef}
                title="계정 선택"
            />

            <div
                style={{
                    height: bodyHeight,
                    display: "flex",
                    flexDirection: "column",
                    width: "90.6%",
                    margin: "0 auto",
                    gap: "16px",
                    paddingBottom: "39px",
                }}
            >
                <div
                    style={{
                        flex: 1,
                        overflowY: "auto",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                    }}
                >
                    <FormControl>
                        <RadioGroup
                            overlay
                            name="member"
                            value={selectedUserId}
                            onChange={(e) => {
                                console.log("e.target.value:", e.target.value)
                                setSelectedUserId((e.target as HTMLInputElement).value)
                            }
                            }
                            orientation="horizontal"
                            sx={{
                                gap: 2,
                                display: "grid",
                                //850px 이하에서는 2열
                                "@media (max-width: 850px)": {
                                    gridTemplateColumns: "1fr 1fr"
                                },
                                //851px 이상에서는 3열
                                "@media (min-width: 851px)": {
                                    gridTemplateColumns: "1fr 1fr 1fr"
                                },
                            }}
                        >
                            {userItems.map((user: any) => (
                                <Sheet
                                    component="label"
                                    key={user._radioId}
                                    variant="outlined"
                                    sx={{
                                        p: 2,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        boxShadow: "sm",
                                        borderRadius: "md",
                                        cursor: "pointer",
                                    }}
                                >
                                    <Radio value={user._radioId} variant="soft" sx={{ mb: 2 }} />

                                    {/* avatar: 0이면 기본 아이콘 */}
                                    {user.avatar ? (
                                        <Avatar
                                            alt={user.name}
                                            src={`/img/avatar/Avatar-${user.avatar}.png`}
                                            sx={{ width: 60, height: 60 }}
                                        />
                                    ) : (
                                        <div
                                            style={{
                                                backgroundColor: "rgba(218, 218, 218, 1)",
                                                width: "60px",
                                                height: "60px",
                                                borderRadius: "50%",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <img
                                                src="img/user-solid.svg"
                                                alt="user"
                                                style={{ width: "65%" }}
                                            />
                                        </div>
                                    )}

                                    {/* ✅ academyTotalSame이 false면 학원이름 표시 */}
                                    {!academyTotalSame && (
                                        <Typography level="body-xs" sx={{ mt: 1, opacity: 0.8 }}>
                                            {user.koreanAcademy}
                                        </Typography>
                                    )}

                                    {/* ✅ 계정이름 + (학생/학부모/직원) */}
                                    <Typography level="body-sm" sx={{ mt: !academyTotalSame ? 0.5 : 1, textAlign: "center" }}>
                                        {displayName(user)}{" "}
                                        <span >
                                            {roleLabel(user.value)}
                                        </span>
                                    </Typography>
                                </Sheet>
                            ))}
                        </RadioGroup>
                    </FormControl>
                </div>

                <div style={{ paddingTop: "0px" }}>
                    <Button fullWidth size="lg" onClick={submit} disabled={!selectedUserId || loading}
                    >
                        {
                            !loading ?
                                "시작하기"
                                :
                                <CircularProgress size={24} style={{ color: "white" }} />
                        }
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default MultipleUserLogin;